import { YStack } from '@/components/ui';
import TextArea from '@/components/ui/TextArea';

export function WebhookSamplePayloadField({
  value,
  error,
  onChange,
}: {
  value: string;
  error: string | null;
  onChange: (next: string) => void;
}) {
  return (
    <YStack className="gap-1">
      <TextArea
        id="webhook-sample-payload"
        aria-label="Sample payload"
        placeholder='e.g. {"type": "invoice.paid", "data": {"amount": 100}}'
        rows={6}
        spellCheck={false}
        value={value}
        error={error ?? undefined}
        onChange={(event) => onChange(event.target.value)}
        className="font-mono text-xs"
      />
      {error ? (
        <span
          id="webhook-sample-payload-error"
          className="text-xs text-danger-11"
        >
          {error}
        </span>
      ) : (
        <span className="text-xs text-foreground-muted">
          Optional. Paste one example of what the service posts, and its fields
          are offered when you write trigger conditions. Only the field names
          and types are kept.
        </span>
      )}
    </YStack>
  );
}
